import searchApi from "~/api/search";

const getSearchById = (context, searchId) => {
  if (context.state.fetchingSearchesIds.indexOf(searchId) !== -1
    || context.getters.hasSearchById(searchId)) {
    return Promise.resolve(context.getters.getSearchById(searchId));
  }

  context.commit("SET_FETCHING_SEARCH_IDS", [searchId]);

  return searchApi.getSearchById(searchId)
    .then((response) => {
      context.commit("UNSET_FETCHING_SEARCH_IDS", [searchId]);
      context.commit("CACHE_SEARCH", response.data);

      return response.data;
    });
};

export default {
  getSearchById,
};
